module.exports = __webpack_public_path__ + "static/media/g-Golden Ratio.723cb033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/g-Golden Ratio.png
// module id = 158
// module chunks = 0